module.exports = __webpack_public_path__ + "img/8681f43.svg";